module.exports = __webpack_public_path__ + "img/01.f0f4650a.png";